import { JsonConverter, JsonCustomConvert } from "json2typescript";

@JsonConverter
export class AntennaModelEnumConverter implements JsonCustomConvert<AntennaModelEnum> {
  serialize() {}

  deserialize(data: any): AntennaModelEnum {
    switch (data) {
      case 'ANT2':
        return AntennaModelEnum.ANT2;
      case 'ANT5':
        return AntennaModelEnum.ANT5;
      case 'OMNI':
        return AntennaModelEnum.OMNI;
      default:
        return AntennaModelEnum.ANT2;
    }
  }
}

export enum AntennaModelEnum {
  ANT2 = 'ANT2',
  ANT5 = 'ANT5',
  OMNI = 'OMNI',
}
